import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Cumulative Progress Report")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Training Partner")
], -1)
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tranche")
], -1)
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Trainee Type", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Start Date")
], -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "End Date")
], -1)
const _hoisted_19 = { class: "col-md-1 mt-2 p-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
    ])
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_25 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_26 = { class: "collapse show" }
const _hoisted_27 = { class: "card-body border-top p-9" }
const _hoisted_28 = {
  class: "col-md-12 text-end mb-3 p-0",
  "data-v-54b12dc8": ""
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "col-md-12 table-responsive sticky" }
const _hoisted_36 = {
  class: "table table-borderless cumulativeProgressInfo",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("thead", {
  style: {"border-left":"1.5px solid #23ce10"},
  class: "sticky-header"
}, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Dropout "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Job Placement "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " % of Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female ")
  ])
], -1)
const _hoisted_38 = { style: {} }
const _hoisted_39 = {
  key: 0,
  class: "fw-bolder bg-light"
}
const _hoisted_40 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "fw-bolder bg-light"
}
const _hoisted_43 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "19",
  class: "align-middle border border-gray-400"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "border border-gray-400 text-left" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_50 = { style: {"font-weight":"bold"} }
const _hoisted_51 = { style: {"font-weight":"bold"} }
const _hoisted_52 = { style: {"font-weight":"bold"} }
const _hoisted_53 = { style: {"font-weight":"bold"} }
const _hoisted_54 = { style: {"font-weight":"bold"} }
const _hoisted_55 = { style: {"font-weight":"bold"} }
const _hoisted_56 = { style: {"font-weight":"bold"} }
const _hoisted_57 = { style: {"font-weight":"bold"} }
const _hoisted_58 = { style: {"font-weight":"bold"} }
const _hoisted_59 = { style: {"font-weight":"bold"} }
const _hoisted_60 = { style: {"font-weight":"bold"} }
const _hoisted_61 = { style: {"font-weight":"bold"} }
const _hoisted_62 = { style: {"font-weight":"bold"} }
const _hoisted_63 = { style: {"font-weight":"bold"} }
const _hoisted_64 = { style: {"font-weight":"bold"} }
const _hoisted_65 = { style: {"font-weight":"bold"} }
const _hoisted_66 = { style: {"font-weight":"bold"} }
const _hoisted_67 = {
  key: 3,
  class: "fw-bolder bg-light"
}
const _hoisted_68 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "19",
  class: "align-middle border border-gray-400"
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { key: 2 }
const _hoisted_72 = ["href"]
const _hoisted_73 = { class: "border border-gray-400 text-left" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_75 = { style: {"font-weight":"bold"} }
const _hoisted_76 = { style: {"font-weight":"bold"} }
const _hoisted_77 = { style: {"font-weight":"bold"} }
const _hoisted_78 = { style: {"font-weight":"bold"} }
const _hoisted_79 = { style: {"font-weight":"bold"} }
const _hoisted_80 = { style: {"font-weight":"bold"} }
const _hoisted_81 = { style: {"font-weight":"bold"} }
const _hoisted_82 = { style: {"font-weight":"bold"} }
const _hoisted_83 = { style: {"font-weight":"bold"} }
const _hoisted_84 = { style: {"font-weight":"bold"} }
const _hoisted_85 = { style: {"font-weight":"bold"} }
const _hoisted_86 = { style: {"font-weight":"bold"} }
const _hoisted_87 = { style: {"font-weight":"bold"} }
const _hoisted_88 = { style: {"font-weight":"bold"} }
const _hoisted_89 = { style: {"font-weight":"bold"} }
const _hoisted_90 = { style: {"font-weight":"bold"} }
const _hoisted_91 = { style: {"font-weight":"bold"} }
const _hoisted_92 = {
  key: 5,
  class: "fw-bolder bg-light"
}
const _hoisted_93 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "19",
  class: "align-middle border border-gray-400"
}
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 2 }
const _hoisted_97 = ["href"]
const _hoisted_98 = { class: "border border-gray-400 text-left" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_100 = { style: {"font-weight":"bold"} }
const _hoisted_101 = { style: {"font-weight":"bold"} }
const _hoisted_102 = { style: {"font-weight":"bold"} }
const _hoisted_103 = { style: {"font-weight":"bold"} }
const _hoisted_104 = { style: {"font-weight":"bold"} }
const _hoisted_105 = { style: {"font-weight":"bold"} }
const _hoisted_106 = { style: {"font-weight":"bold"} }
const _hoisted_107 = { style: {"font-weight":"bold"} }
const _hoisted_108 = { style: {"font-weight":"bold"} }
const _hoisted_109 = { style: {"font-weight":"bold"} }
const _hoisted_110 = { style: {"font-weight":"bold"} }
const _hoisted_111 = { style: {"font-weight":"bold"} }
const _hoisted_112 = { style: {"font-weight":"bold"} }
const _hoisted_113 = { style: {"font-weight":"bold"} }
const _hoisted_114 = { style: {"font-weight":"bold"} }
const _hoisted_115 = { style: {"font-weight":"bold"} }
const _hoisted_116 = { style: {"font-weight":"bold"} }
const _hoisted_117 = {
  key: 7,
  class: "fw-bolder bg-light"
}
const _hoisted_118 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "19",
  class: "align-middle border border-gray-400"
}
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { key: 2 }
const _hoisted_122 = ["href"]
const _hoisted_123 = { class: "border border-gray-400 text-left" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_125 = { style: {"font-weight":"bold"} }
const _hoisted_126 = { style: {"font-weight":"bold"} }
const _hoisted_127 = { style: {"font-weight":"bold"} }
const _hoisted_128 = { style: {"font-weight":"bold"} }
const _hoisted_129 = { style: {"font-weight":"bold"} }
const _hoisted_130 = { style: {"font-weight":"bold"} }
const _hoisted_131 = { style: {"font-weight":"bold"} }
const _hoisted_132 = { style: {"font-weight":"bold"} }
const _hoisted_133 = { style: {"font-weight":"bold"} }
const _hoisted_134 = { style: {"font-weight":"bold"} }
const _hoisted_135 = { style: {"font-weight":"bold"} }
const _hoisted_136 = { style: {"font-weight":"bold"} }
const _hoisted_137 = { style: {"font-weight":"bold"} }
const _hoisted_138 = { style: {"font-weight":"bold"} }
const _hoisted_139 = { style: {"font-weight":"bold"} }
const _hoisted_140 = { style: {"font-weight":"bold"} }
const _hoisted_141 = { style: {"font-weight":"bold"} }
const _hoisted_142 = {
  key: 9,
  class: "border border-gray-400 text-left"
}
const _hoisted_143 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_144 = /*#__PURE__*/_createElementVNode("span", null, "(A+B+C) ", -1)
const _hoisted_145 = { style: {"font-weight":"bold"} }
const _hoisted_146 = { style: {"font-weight":"bold"} }
const _hoisted_147 = { style: {"font-weight":"bold"} }
const _hoisted_148 = { style: {"font-weight":"bold"} }
const _hoisted_149 = { style: {"font-weight":"bold"} }
const _hoisted_150 = { style: {"font-weight":"bold"} }
const _hoisted_151 = { style: {"font-weight":"bold"} }
const _hoisted_152 = { style: {"font-weight":"bold"} }
const _hoisted_153 = { style: {"font-weight":"bold"} }
const _hoisted_154 = { style: {"font-weight":"bold"} }
const _hoisted_155 = { style: {"font-weight":"bold"} }
const _hoisted_156 = { style: {"font-weight":"bold"} }
const _hoisted_157 = { style: {"font-weight":"bold"} }
const _hoisted_158 = { style: {"font-weight":"bold"} }
const _hoisted_159 = { style: {"font-weight":"bold"} }
const _hoisted_160 = { style: {"font-weight":"bold"} }
const _hoisted_161 = { style: {"font-weight":"bold"} }
const _hoisted_162 = {
  key: 10,
  class: "border border-gray-400 text-left"
}
const _hoisted_163 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_164 = /*#__PURE__*/_createElementVNode("span", null, "(D+E+F+G) ", -1)
const _hoisted_165 = { style: {"font-weight":"bold"} }
const _hoisted_166 = { style: {"font-weight":"bold"} }
const _hoisted_167 = { style: {"font-weight":"bold"} }
const _hoisted_168 = { style: {"font-weight":"bold"} }
const _hoisted_169 = { style: {"font-weight":"bold"} }
const _hoisted_170 = { style: {"font-weight":"bold"} }
const _hoisted_171 = { style: {"font-weight":"bold"} }
const _hoisted_172 = { style: {"font-weight":"bold"} }
const _hoisted_173 = { style: {"font-weight":"bold"} }
const _hoisted_174 = { style: {"font-weight":"bold"} }
const _hoisted_175 = { style: {"font-weight":"bold"} }
const _hoisted_176 = { style: {"font-weight":"bold"} }
const _hoisted_177 = { style: {"font-weight":"bold"} }
const _hoisted_178 = { style: {"font-weight":"bold"} }
const _hoisted_179 = { style: {"font-weight":"bold"} }
const _hoisted_180 = { style: {"font-weight":"bold"} }
const _hoisted_181 = { style: {"font-weight":"bold"} }
const _hoisted_182 = {
  key: 11,
  class: "border border-gray-400 text-left"
}
const _hoisted_183 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_184 = /*#__PURE__*/_createElementVNode("span", null, " (K+L+M+N) ", -1)
const _hoisted_185 = { style: {"font-weight":"bold"} }
const _hoisted_186 = { style: {"font-weight":"bold"} }
const _hoisted_187 = { style: {"font-weight":"bold"} }
const _hoisted_188 = { style: {"font-weight":"bold"} }
const _hoisted_189 = { style: {"font-weight":"bold"} }
const _hoisted_190 = { style: {"font-weight":"bold"} }
const _hoisted_191 = { style: {"font-weight":"bold"} }
const _hoisted_192 = { style: {"font-weight":"bold"} }
const _hoisted_193 = { style: {"font-weight":"bold"} }
const _hoisted_194 = { style: {"font-weight":"bold"} }
const _hoisted_195 = { style: {"font-weight":"bold"} }
const _hoisted_196 = { style: {"font-weight":"bold"} }
const _hoisted_197 = { style: {"font-weight":"bold"} }
const _hoisted_198 = { style: {"font-weight":"bold"} }
const _hoisted_199 = { style: {"font-weight":"bold"} }
const _hoisted_200 = { style: {"font-weight":"bold"} }
const _hoisted_201 = { style: {"font-weight":"bold"} }
const _hoisted_202 = { class: "border border-gray-400 text-left" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Grand Total (All Tranches) ")
], -1)
const _hoisted_204 = { style: {"font-weight":"bold"} }
const _hoisted_205 = { style: {"font-weight":"bold"} }
const _hoisted_206 = { style: {"font-weight":"bold"} }
const _hoisted_207 = { style: {"font-weight":"bold"} }
const _hoisted_208 = { style: {"font-weight":"bold"} }
const _hoisted_209 = { style: {"font-weight":"bold"} }
const _hoisted_210 = { style: {"font-weight":"bold"} }
const _hoisted_211 = { style: {"font-weight":"bold"} }
const _hoisted_212 = { style: {"font-weight":"bold"} }
const _hoisted_213 = { style: {"font-weight":"bold"} }
const _hoisted_214 = { style: {"font-weight":"bold"} }
const _hoisted_215 = { style: {"font-weight":"bold"} }
const _hoisted_216 = { style: {"font-weight":"bold"} }
const _hoisted_217 = { style: {"font-weight":"bold"} }
const _hoisted_218 = { style: {"font-weight":"bold"} }
const _hoisted_219 = { style: {"font-weight":"bold"} }
const _hoisted_220 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.TpartnerData,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.TpartnerData) = $event)),
                      options: _ctx.optionsTPartner,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Training Partner",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.TranceData,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.TranceData) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "--Select--",
                      modelValue: _ctx.report_type,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.report_type) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, { value: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("--Select--")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "1",
                          label: "Poor"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Poor")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "2",
                          label: "Ethnic Minority"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ethnic Minority")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "3",
                          label: "Physically Disable"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Physically Disable")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.start_date,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.start_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.end_date,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.end_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          type: "date",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cumulativeProgress())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_20
                    ])
                  ])
                ]),
                (_ctx.showTrainningStatistics == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                  : _createCommentVNode("", true),
                (_ctx.showTrainningStatistics == true)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _hoisted_24,
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_30),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_32),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_34)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("table", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("tbody", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.cumulativeProgressInfo, (info, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                      (info != null)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                                            _createElementVNode("td", _hoisted_40, [
                                              (info?.TrancheInfo)
                                                ? (_openBlock(), _createElementBlock("b", _hoisted_41, _toDisplayString(info?.TrancheInfo?.tranche_name), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.private &&
                                      info?.private?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                            (
                                        info?.private?.association?.entities !=
                                        ''
                                      )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                                  (key == 1)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_44, " A. Industry Associations "))
                                                    : _createCommentVNode("", true),
                                                  (key == 2)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_45, " D. Industry Associations "))
                                                    : _createCommentVNode("", true),
                                                  (key == 5)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_46, " K. Industry Associations "))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.private &&
                                      info?.private?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedEntityKeys(
                                        info?.private?.association?.entities
                                      ), (data, inx, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: index,
                                                class: "border border-gray-400 text-left"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("a", {
                                                    href: 
                                              `${this.VUE_APP_TMS}/course-summary/2/` +
                                              key +
                                              '/' +
                                               data?.entity_id 
                                            ,
                                                    target: "_blank",
                                                    class: "text-primary fw-bold fs-6 mt-2"
                                                  }, _toDisplayString(data?.entity_name), 9, _hoisted_47)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(data?.target_trainee !== undefined
                                              ? Number(
                                                  data?.target_trainee
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.enrollment !== undefined
                                              ? Number(
                                                  data?.enrollment
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll !== undefined
                                              ? Number(
                                                  data?.female_enroll
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_enroll_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_dropout !== undefined
                                              ? Number(
                                                  data?.total_dropout
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.dropout_female !== undefined
                                              ? Number(
                                                  data?.dropout_female
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_dropout_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_dropout_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_assessed !== undefined
                                              ? Number(
                                                  data?.total_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assessed !== undefined
                                              ? Number(
                                                  data?.female_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assesment_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_assesment_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_certified !== undefined
                                              ? Number(
                                                  data?.total_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified !== undefined
                                              ? Number(
                                                  data?.female_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_certified_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.total_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.female_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_job_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_job_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                              undefined &&
                                            data?.total_certified !== undefined
                                              ? data?.total_certified == 0
                                                ? 0
                                                : Math.round(
                                                    (data?.total_jobplacement /
                                                      data?.total_certified) *
                                                      100
                                                  )
                                              : 0), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_48, [
                                              _hoisted_49,
                                              _createElementVNode("td", _hoisted_50, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalTargetTrainee !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subTotalTargetTrainee
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_51, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalEnrollment !== undefined
                                              ? info?.private?.association
                                                  ?.subTotalEnrollment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_52, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalEnrollmentFemale !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subTotalEnrollmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_53, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subtotal_female_enroll_percentage !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subtotal_female_enroll_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_54, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalDropout !== undefined
                                              ? info?.private?.association
                                                  ?.subTotalDropout
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_55, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalDropoutFemale !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subTotalDropoutFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_56, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subtotal_female_dropout_percentage !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subtotal_female_dropout_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_57, _toDisplayString(Number(
                                            info?.private?.association
                                              .subTotalAssesment !== undefined
                                              ? info?.private?.association
                                                  .subTotalAssesment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_58, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalAssesmentFemale !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subTotalAssesmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_59, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subtotal_female_assesed_percentage !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subtotal_female_assesed_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_60, _toDisplayString(Number(
                                            info?.private?.association
                                              .subTotalcertified !== undefined
                                              ? info?.private?.association
                                                  .subTotalcertified
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_61, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotalcertifiedFemale !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subTotalcertifiedFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_62, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subtotal_female_certified_percentage !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subtotal_female_certified_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_63, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotaljob !== undefined
                                              ? info?.private?.association
                                                  ?.subTotaljob
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_64, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subTotaljobFemale !== undefined
                                              ? info?.private?.association
                                                  ?.subTotaljobFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_65, _toDisplayString(Number(
                                            info?.private?.association
                                              ?.subtotal_female_job_percentage !==
                                              undefined
                                              ? info?.private?.association
                                                  ?.subtotal_female_job_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_66, _toDisplayString(info?.private?.association
                                            .subTotalcertified == 0 ||
                                          info?.private?.association
                                            .subTotalcertified === undefined ||
                                          info?.private?.association
                                            ?.subTotaljob === undefined
                                            ? 0
                                            : Math.round(
                                                (info?.private?.association
                                                  ?.subTotaljob /
                                                  info?.private?.association
                                                    ?.subTotalcertified) *
                                                  100
                                              )), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.gov &&
                                      info?.gov?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [
                                            (
                                        info?.gov?.association?.entities != ''
                                      )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                                  (key == 1)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_69, " B. Govt. Partners "))
                                                    : _createCommentVNode("", true),
                                                  (key == 2)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_70, " E. Govt. Partners "))
                                                    : _createCommentVNode("", true),
                                                  (key == 5)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_71, " L. Govt. Partners "))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.gov &&
                                      info?.gov?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedEntityKeys(
                                        info?.gov?.association?.entities
                                      ), (data, inx, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: index,
                                                class: "border border-gray-400 text-left"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("a", {
                                                    href: 
                                              `${this.VUE_APP_TMS}/course-summary/2/` +
                                              key +
                                              '/' +
                                             data?.entity_id 
                                            ,
                                                    target: "_blank",
                                                    class: "text-primary fw-bold fs-6 mt-2"
                                                  }, _toDisplayString(data?.entity_name), 9, _hoisted_72)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(data?.target_trainee !== undefined
                                              ? Number(
                                                  data?.target_trainee
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.enrollment !== undefined
                                              ? Number(
                                                  data?.enrollment
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll !== undefined
                                              ? Number(
                                                  data?.female_enroll
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_enroll_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_dropout !== undefined
                                              ? Number(
                                                  data?.total_dropout
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.dropout_female !== undefined
                                              ? Number(
                                                  data?.dropout_female
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_dropout_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_dropout_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_assessed !== undefined
                                              ? Number(
                                                  data?.total_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assessed !== undefined
                                              ? Number(
                                                  data?.female_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assesment_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_assesment_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_certified !== undefined
                                              ? Number(
                                                  data?.total_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified !== undefined
                                              ? Number(
                                                  data?.female_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_certified_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.total_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.female_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_job_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_job_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                              undefined &&
                                            data?.total_certified !== undefined
                                              ? data?.total_certified == 0
                                                ? 0
                                                : Math.round(
                                                    (data?.total_jobplacement /
                                                      data?.total_certified) *
                                                      100
                                                  )
                                              : 0), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_73, [
                                              _hoisted_74,
                                              _createElementVNode("td", _hoisted_75, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalTargetTrainee !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subTotalTargetTrainee
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_76, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalEnrollment !== undefined
                                              ? info?.gov?.association
                                                  ?.subTotalEnrollment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_77, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalEnrollmentFemale !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subTotalEnrollmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_78, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subtotal_female_enroll_percentage !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subtotal_female_enroll_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_79, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalDropout !== undefined
                                              ? info?.gov?.association
                                                  ?.subTotalDropout
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_80, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalDropoutFemale !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subTotalDropoutFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_81, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subtotal_female_dropout_percentage !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subtotal_female_dropout_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_82, _toDisplayString(Number(
                                            info?.gov?.association
                                              .subTotalAssesment !== undefined
                                              ? info?.gov?.association
                                                  .subTotalAssesment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_83, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalAssesmentFemale !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subTotalAssesmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_84, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subtotal_female_assesed_percentage !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subtotal_female_assesed_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_85, _toDisplayString(Number(
                                            info?.gov?.association
                                              .subTotalcertified !== undefined
                                              ? info?.gov?.association
                                                  .subTotalcertified
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_86, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotalcertifiedFemale !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subTotalcertifiedFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_87, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subtotal_female_certified_percentage !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subtotal_female_certified_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_88, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotaljob !== undefined
                                              ? info?.gov?.association
                                                  ?.subTotaljob
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_89, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subTotaljobFemale !== undefined
                                              ? info?.gov?.association
                                                  ?.subTotaljobFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_90, _toDisplayString(Number(
                                            info?.gov?.association
                                              ?.subtotal_female_job_percentage !==
                                              undefined
                                              ? info?.gov?.association
                                                  ?.subtotal_female_job_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_91, _toDisplayString(info?.gov?.association
                                            .subTotalcertified == 0 ||
                                          info?.gov?.association
                                            .subTotalcertified === undefined ||
                                          info?.gov?.association
                                            ?.subTotaljob === undefined
                                            ? 0
                                            : Math.round(
                                                (info?.gov?.association
                                                  ?.subTotaljob /
                                                  info?.gov?.association
                                                    ?.subTotalcertified) *
                                                  100
                                              )), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.motor &&
                                      info?.motor?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_92, [
                                            (
                                        info?.motor?.association?.entities != ''
                                      )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_93, [
                                                  (key == 1)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_94, " C. Motor Driving"))
                                                    : _createCommentVNode("", true),
                                                  (key == 2)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_95, " F. Motor Driving"))
                                                    : _createCommentVNode("", true),
                                                  (key == 5)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_96, " M. Motor Driving"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.motor &&
                                      info?.motor?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedEntityKeys(
                                        info?.motor?.association?.entities
                                      ), (data, inx, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: index,
                                                class: "border border-gray-400 text-left"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("a", {
                                                    href: 
                                              `${this.VUE_APP_TMS}/course-summary/1/` +
                                              key +
                                              '/' +
                                              data?.entity_id 
                                            ,
                                                    target: "_blank",
                                                    class: "text-primary fw-bold fs-6 mt-2"
                                                  }, _toDisplayString(data?.entity_name), 9, _hoisted_97)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(data?.target_trainee !== undefined
                                              ? Number(
                                                  data?.target_trainee
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.enrollment !== undefined
                                              ? Number(
                                                  data?.enrollment
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll !== undefined
                                              ? Number(
                                                  data?.female_enroll
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_enroll_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_dropout !== undefined
                                              ? Number(
                                                  data?.total_dropout
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.dropout_female !== undefined
                                              ? Number(
                                                  data?.dropout_female
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_dropout_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_dropout_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_assessed !== undefined
                                              ? Number(
                                                  data?.total_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assessed !== undefined
                                              ? Number(
                                                  data?.female_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assesment_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_assesment_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_certified !== undefined
                                              ? Number(
                                                  data?.total_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified !== undefined
                                              ? Number(
                                                  data?.female_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_certified_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.total_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.female_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_job_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_job_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                              undefined &&
                                            data?.total_certified !== undefined
                                              ? data?.total_certified == 0
                                                ? 0
                                                : Math.round(
                                                    (data?.total_jobplacement /
                                                      data?.total_certified) *
                                                      100
                                                  )
                                              : 0), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_98, [
                                              _hoisted_99,
                                              _createElementVNode("td", _hoisted_100, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalTargetTrainee !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subTotalTargetTrainee
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_101, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalEnrollment !== undefined
                                              ? info?.motor?.association
                                                  ?.subTotalEnrollment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_102, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalEnrollmentFemale !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subTotalEnrollmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_103, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subtotal_female_enroll_percentage !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subtotal_female_enroll_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_104, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalDropout !== undefined
                                              ? info?.motor?.association
                                                  ?.subTotalDropout
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_105, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalDropoutFemale !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subTotalDropoutFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_106, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subtotal_female_dropout_percentage !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subtotal_female_dropout_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_107, _toDisplayString(Number(
                                            info?.motor?.association
                                              .subTotalAssesment !== undefined
                                              ? info?.motor?.association
                                                  .subTotalAssesment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_108, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalAssesmentFemale !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subTotalAssesmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_109, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subtotal_female_assesed_percentage !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subtotal_female_assesed_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_110, _toDisplayString(Number(
                                            info?.motor?.association
                                              .subTotalcertified !== undefined
                                              ? info?.motor?.association
                                                  .subTotalcertified
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_111, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotalcertifiedFemale !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subTotalcertifiedFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_112, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subtotal_female_certified_percentage !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subtotal_female_certified_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_113, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotaljob !== undefined
                                              ? info?.motor?.association
                                                  ?.subTotaljob
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_114, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subTotaljobFemale !== undefined
                                              ? info?.motor?.association
                                                  ?.subTotaljobFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_115, _toDisplayString(Number(
                                            info?.motor?.association
                                              ?.subtotal_female_job_percentage !==
                                              undefined
                                              ? info?.motor?.association
                                                  ?.subtotal_female_job_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_116, _toDisplayString(info?.motor?.association
                                            .subTotalcertified == 0 ||
                                          info?.motor?.association
                                            .subTotalcertified === undefined ||
                                          info?.motor?.association
                                            ?.subTotaljob === undefined
                                            ? 0
                                            : Math.round(
                                                (info?.motor?.association
                                                  ?.subTotaljob /
                                                  info?.motor?.association
                                                    ?.subTotalcertified) *
                                                  100
                                              )), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.edc &&
                                      info?.edc?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_117, [
                                            (
                                        info?.edc?.association?.entities != ''
                                      )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_118, [
                                                  (key == 1)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_119, " D. Excecutive Development Program"))
                                                    : _createCommentVNode("", true),
                                                  (key == 2)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_120, " G. Excecutive Development Program"))
                                                    : _createCommentVNode("", true),
                                                  (key == 5)
                                                    ? (_openBlock(), _createElementBlock("b", _hoisted_121, " N. Excecutive Development Program"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                                      info?.edc &&
                                      info?.edc?.association?.entities != ''
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedEntityKeys(
                                        info?.edc?.association?.entities
                                      ), (data, inx, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: index,
                                                class: "border border-gray-400 text-left"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("a", {
                                                    href: 
                                              `${this.VUE_APP_TMS}/course-summary/2/` +
                                              key +
                                              '/' +
                                              data?.entity_id
                                            ,
                                                    target: "_blank",
                                                    class: "text-primary fw-bold fs-6 mt-2"
                                                  }, _toDisplayString(data?.entity_name), 9, _hoisted_122)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(data?.target_trainee !== undefined
                                              ? Number(
                                                  data?.target_trainee
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.enrollment !== undefined
                                              ? Number(
                                                  data?.enrollment
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll !== undefined
                                              ? Number(
                                                  data?.female_enroll
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_enroll_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_enroll_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_dropout !== undefined
                                              ? Number(
                                                  data?.total_dropout
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.dropout_female !== undefined
                                              ? Number(
                                                  data?.dropout_female
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_dropout_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_dropout_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_assessed !== undefined
                                              ? Number(
                                                  data?.total_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assessed !== undefined
                                              ? Number(
                                                  data?.female_assessed
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_assesment_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_assesment_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_certified !== undefined
                                              ? Number(
                                                  data?.total_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified !== undefined
                                              ? Number(
                                                  data?.female_certified
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_certified_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_certified_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.total_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_jobplacement !==
                                            undefined
                                              ? Number(
                                                  data?.female_jobplacement
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.female_job_percentage !==
                                            undefined
                                              ? Number(
                                                  data?.female_job_percentage
                                                ).toLocaleString()
                                              : 0), 1),
                                                _createElementVNode("td", null, _toDisplayString(data?.total_jobplacement !==
                                              undefined &&
                                            data?.total_certified !== undefined
                                              ? data?.total_certified == 0
                                                ? 0
                                                : Math.round(
                                                    (data?.total_jobplacement /
                                                      data?.total_certified) *
                                                      100
                                                  )
                                              : 0), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_123, [
                                              _hoisted_124,
                                              _createElementVNode("td", _hoisted_125, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalTargetTrainee !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subTotalTargetTrainee
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_126, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalEnrollment !== undefined
                                              ? info?.edc?.association
                                                  ?.subTotalEnrollment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_127, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalEnrollmentFemale !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subTotalEnrollmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_128, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subtotal_female_enroll_percentage !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subtotal_female_enroll_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_129, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalDropout !== undefined
                                              ? info?.edc?.association
                                                  ?.subTotalDropout
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_130, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalDropoutFemale !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subTotalDropoutFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_131, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subtotal_female_dropout_percentage !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subtotal_female_dropout_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_132, _toDisplayString(Number(
                                            info?.edc?.association
                                              .subTotalAssesment !== undefined
                                              ? info?.edc?.association
                                                  .subTotalAssesment
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_133, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalAssesmentFemale !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subTotalAssesmentFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_134, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subtotal_female_assesed_percentage !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subtotal_female_assesed_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_135, _toDisplayString(Number(
                                            info?.edc?.association
                                              .subTotalcertified !== undefined
                                              ? info?.edc?.association
                                                  .subTotalcertified
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_136, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotalcertifiedFemale !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subTotalcertifiedFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_137, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subtotal_female_certified_percentage !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subtotal_female_certified_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_138, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotaljob !== undefined
                                              ? info?.edc?.association
                                                  ?.subTotaljob
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_139, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subTotaljobFemale !== undefined
                                              ? info?.edc?.association
                                                  ?.subTotaljobFemale
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_140, _toDisplayString(Number(
                                            info?.edc?.association
                                              ?.subtotal_female_job_percentage !==
                                              undefined
                                              ? info?.edc?.association
                                                  ?.subtotal_female_job_percentage
                                              : 0
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_141, _toDisplayString(info?.edc?.association
                                            .subTotalcertified == 0 ||
                                          info?.edc?.association
                                            .subTotalcertified === undefined ||
                                          info?.edc?.association
                                            ?.subTotaljob === undefined
                                            ? 0
                                            : Math.round(
                                                (info?.edc?.association
                                                  ?.subTotaljob /
                                                  info?.edc?.association
                                                    ?.subTotalcertified) *
                                                  100
                                              )), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (info?.TrancheInfo.id == 1)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_142, [
                                            _createElementVNode("td", _hoisted_143, [
                                              _createElementVNode("b", null, [
                                                _createTextVNode("Total " + _toDisplayString(info?.TrancheInfo?.tranche_name) + " ", 1),
                                                _hoisted_144
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_145, _toDisplayString((
                                          Number(info?.TotalTargetTrainee)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_146, _toDisplayString((info?.TotalEnrollment? Number(info?.TotalEnrollment): 0).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_147, _toDisplayString((info?.TotalEnrollmentFemale
                                          ? Number(info?.TotalEnrollmentFemale)
                                          : 0
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_148, _toDisplayString((info?.total_female_enroll_percentage
                                          ? Number(
                                              info?.total_female_enroll_percentage
                                            )
                                          : 0
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_149, _toDisplayString((
                                          Number(info?.TotalDropout)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_150, _toDisplayString((
                                          Number(info?.TotalDropoutFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_151, _toDisplayString((
                                          Number(
                                            info?.total_female_dropout_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_152, _toDisplayString((
                                          Number(info?.TotalAssesment)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_153, _toDisplayString((
                                          Number(info?.TotalAssesmentFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_154, _toDisplayString((
                                          Number(
                                            info?.total_female_assesed_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_155, _toDisplayString((
                                          Number(info?.Totalcertified)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_156, _toDisplayString((
                                          Number(info?.TotalcertifiedFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_157, _toDisplayString((
                                          Number(
                                            info?.total_female_certified_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_158, _toDisplayString((
                                          Number(info?.Totaljob)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_159, _toDisplayString((
                                          Number(info?.TotaljobFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_160, _toDisplayString((
                                          Number(
                                            info?.total_female_job_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_161, _toDisplayString((info?.Totalcertified !== undefined &&
                                        info?.Totalcertified !== 0
                                          ? Math.round(
                                              (info?.Totaljob /
                                                info?.Totalcertified) *
                                                100
                                            )
                                          : 0)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (info?.TrancheInfo?.id == 2)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_162, [
                                            _createElementVNode("td", _hoisted_163, [
                                              _createElementVNode("b", null, [
                                                _createTextVNode("Total " + _toDisplayString(info?.TrancheInfo?.tranche_name) + " ", 1),
                                                _hoisted_164
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_165, _toDisplayString((
                                          Number(info?.TotalTargetTrainee)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_166, _toDisplayString((
                                          Number(info?.TotalEnrollment)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_167, _toDisplayString((
                                          Number(info?.TotalEnrollmentFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_168, _toDisplayString((
                                          Number(
                                            info?.total_female_enroll_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_169, _toDisplayString((
                                          Number(info?.TotalDropout)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_170, _toDisplayString((
                                          Number(info?.TotalDropoutFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_171, _toDisplayString((
                                          Number(
                                            info?.total_female_dropout_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_172, _toDisplayString((
                                          Number(info?.TotalAssesment)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_173, _toDisplayString((
                                          Number(info?.TotalAssesmentFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_174, _toDisplayString((
                                          Number(
                                            info?.total_female_assesed_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_175, _toDisplayString((
                                          Number(info?.Totalcertified)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_176, _toDisplayString((
                                          Number(info?.TotalcertifiedFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_177, _toDisplayString((
                                          Number(
                                            info?.total_female_certified_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_178, _toDisplayString((
                                          Number(info?.Totaljob)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_179, _toDisplayString((
                                          Number(info?.TotaljobFemale)
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_180, _toDisplayString((
                                          Number(
                                            info?.total_female_job_percentage
                                          )
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_181, _toDisplayString((info?.Totalcertified !== undefined &&
                                        info?.Totalcertified !== 0
                                          ? Math.round(
                                              (info?.Totaljob /
                                                info?.Totalcertified) *
                                                100
                                            )
                                          : 0)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (info?.TrancheInfo?.id == 5)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_182, [
                                            _createElementVNode("td", _hoisted_183, [
                                              _createElementVNode("b", null, [
                                                _createTextVNode("Total " + _toDisplayString(info?.TrancheInfo?.tranche_name) + " ", 1),
                                                _hoisted_184
                                              ])
                                            ]),
                                            _createElementVNode("td", _hoisted_185, _toDisplayString(Number(
                                          info?.TotalTargetTrainee
                                        ).toLocaleString()), 1),
                                            _createElementVNode("td", _hoisted_186, _toDisplayString(info?.TotalEnrollment != undefined
                                          ? Number(
                                              info?.TotalEnrollment
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_187, _toDisplayString(info?.TotalEnrollmentFemale
                                          ? Number(
                                              info?.TotalEnrollmentFemale
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_188, _toDisplayString(info?.total_female_enroll_percentage
                                          ? Number(
                                              info?.total_female_enroll_percentage
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_189, _toDisplayString(info?.TotalDropout
                                          ? Number(
                                              info?.TotalDropout
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_190, _toDisplayString(info?.TotalDropoutFemale
                                          ? Number(
                                              info?.TotalDropoutFemale
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_191, _toDisplayString(info?.total_female_dropout_percentage
                                          ? Number(
                                              info?.total_female_dropout_percentage
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_192, _toDisplayString(info?.TotalAssesment
                                          ? Number(
                                              info?.TotalAssesment
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_193, _toDisplayString(info?.TotalAssesmentFemale
                                          ? Number(
                                              info?.TotalAssesmentFemale
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_194, _toDisplayString(info?.total_female_assesed_percentage
                                          ? Number(
                                              info?.total_female_assesed_percentage
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_195, _toDisplayString(info?.Totalcertified
                                          ? Number(
                                              info?.Totalcertified
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_196, _toDisplayString(info?.TotalcertifiedFemale
                                          ? Number(
                                              info?.TotalcertifiedFemale
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_197, _toDisplayString(info?.total_female_certified_percentage
                                          ? Number(
                                              info?.total_female_certified_percentage
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_198, _toDisplayString(info?.Totaljob
                                          ? Number(
                                              info?.Totaljob
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_199, _toDisplayString(info?.TotaljobFemale
                                          ? Number(
                                              info?.TotaljobFemale
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_200, _toDisplayString(info?.total_female_job_percentage
                                          ? Number(
                                              info?.total_female_job_percentage
                                            ).toLocaleString()
                                          : 0), 1),
                                            _createElementVNode("td", _hoisted_201, _toDisplayString(info?.Totalcertified !== undefined &&
                                        info?.Totalcertified !== 0
                                          ? Math.round(
                                              (info?.Totaljob /
                                                info?.Totalcertified) *
                                                100
                                            )
                                          : 0), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_202, [
                                    _hoisted_203,
                                    _createElementVNode("td", _hoisted_204, _toDisplayString(Number(
                                        this.GrandTotalTargetTrainee
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_205, _toDisplayString(Number(
                                        this.GrandTotalEnrollment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_206, _toDisplayString(Number(
                                        this.GrandTotalFemaleEnrollment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_207, _toDisplayString(Number(
                                        this
                                          .GrandTotalFemalePercentageEnrollment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_208, _toDisplayString(Number(
                                        this.GrandTotalDropout
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_209, _toDisplayString(Number(
                                        this.GrandTotalFemaleDropout
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_210, _toDisplayString(Number(
                                        this.GrandTotalFemalePercentageDropout
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_211, _toDisplayString(Number(
                                        this.GrandTotalAssesment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_212, _toDisplayString(this.GrandTotalFemaleAssesment.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_213, _toDisplayString(this.GrandTotalFemalePercentageAssesment.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_214, _toDisplayString(this.GrandTotalCertificate.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_215, _toDisplayString(this.GrandTotalFemaleCertificate.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_216, _toDisplayString(this.GrandTotalFemalePercentageCertificate.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_217, _toDisplayString(this.GrandTotalJobplace.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_218, _toDisplayString(this.GrandTotalFemaleJobplace.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_219, _toDisplayString(this.GrandTotalFemalePercentageJobplace.toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_220, _toDisplayString(this.GrandTotalPercentageOfJobPlacement.toLocaleString()), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])), [
                        [_directive_loading, _ctx.load]
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}